<template>
	<body class="vsc-initialized">
		<main class="d-flex flex-nowrap">
			<RouterView class="router" :formatarDataInicioMes="formatarDataInicioMes" />
		</main>

		<footer class="footer d-print-none w-100" style="bottom: 0px">
			<div class="container-fluid">
				<div class="row">
					<!-- <div class="fundo col-md-4">Ágape Sistemas</div> -->
					<div class="address fundo col-md-6 col-sm-6 col-xs-6">
						Need Help - Versão {{ state.versao }}
					</div>
					<div class="address fundo col-md-6 col-sm-6 col-xs-6">
						<a class="link" href="https://needhelp.com.br/" target="_blank">Sobre Nós</a>
					</div>
					<!-- <div class="fundo col-md-4">
            <div class="">
              <a class="">About</a>
              <a class="">Support</a>
              <a class="">Contact Us</a>
            </div>
          </div> -->
				</div>
			</div>
		</footer>
	</body>
</template>

<script setup>
import api from './api/api';
import { RouterView } from 'vue-router';
import moment from 'moment';
import _versao from '@/../package.json';
import { onMounted, reactive } from 'vue';
import store from './store/store';
import roteador from './roteador/indexRoteador';
// moment.updateLocale('pt-br', {
//   months: [
//     "de Janeiro de", "de Fevereiro de", "de Março de", "de Abril de", "de Maio de", "de Junho de",
//     "de Julho de", "de Agosto de", "de Setembro de", "de Outrubro de", "de Novembro de", "de Dezembro de"
//   ]
// });
const state = reactive({
	versao: _versao.version,
});

onMounted(async () => {
	await api.carregaConfig().then(resp => { store.commit('setConfig', resp); });
	await api.listarSetor().then(resp => { store.commit('setSetores', resp); });
	await api.listarTipoChamado().then(resp => { store.commit('setTipoChamado', resp); });
	setInterval(() => {
		if (roteador.currentRoute.value.name != 'Principal' && roteador.currentRoute.value.name != 'Geral' && roteador.currentRoute.value.name != 'Filtro') {
			if (new Date() > new Date(Number(sessionStorage.getItem("TokenDuracaoPainel")))) {
				if (sessionStorage.getItem("TokenDuracaoPainel") || sessionStorage.getItem("TokenDuracaoPainel") == null) {
					sessionStorage.removeItem("TokenReguaPainel");
					sessionStorage.removeItem("TokenDuracaoPainel");
					sessionStorage.setItem("TokenExpiradoPainel", true);
					sessionStorage.setItem("TokenDuracaoPainel", new Date(new Date().setDate() + 1));
					roteador.push("/login");
					// location.reload();
				}
			}
		}
	}, 1000);
});

const formatarDataInicioMes = (pData) => {
	let aux = "";
	if (pData.getDate() >= 1) {
		aux += (pData.getMonth() + 1 > 9) ?
			`${pData.getMonth() + 1}/01/${pData.getFullYear()}`
			:
			`0${pData.getMonth() + 1}/01/${pData.getFullYear()}`;
	}
	return aux;
};
</script>

<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
} */
#app {
	overflow-x: hidden;
}

:root {
	--tamanho: 10px;
}

.address {
	/* 
  width: 100%;
  font-size: 0.8rem;
  */
	font-style: italic;
	font-weight: lighter;
	align-items: flex-end;
	text-align: center;
}

.fundo {
	background-color: var(--corNav);
}

.router {
	min-height: 97.5vh;
}

.link {
	color: black;
	text-decoration: none;
}
</style>
